import type { PolicyViewModel } from 'src/api/types/PolicyViewModel';

import Grid from '@mui/material/Grid';

import { InfoBox } from '../../shared/components/info-box';

type CoverageReadOnlyFieldsProps = {
  comboId: number;
  viewPolicy: PolicyViewModel;
};

export function CoverageReadOnlyFields({ comboId, viewPolicy }: Readonly<CoverageReadOnlyFieldsProps>) {
  return (
    <>
      <Grid size={{ xs: 8, md: 4 }}>
        <InfoBox
          label="Combo ID"
          value={comboId || ''}
          testIdLabel="combo-id-label"
          testIdValue="combo-id-value"
        />
      </Grid>
      <Grid size={{ xs: 8, md: 4 }}>
        <InfoBox
          label="Coverage ID"
          value={viewPolicy?.coverageId?.toString() || ''}
          testIdLabel="coverage-id-label"
          testIdValue="coverage-id-value"
        />
      </Grid>
      <Grid size={{ xs: 8, md: 4 }}>
        <InfoBox
          label="Coverage name"
          value={viewPolicy?.coverageName ?? ''}
          testIdLabel="coverage-name-label"
          testIdValue="coverage-name-value"
        />
      </Grid>
    </>
  );
}

type PolicyReadOnlyFieldsProps = {
  viewPolicy: PolicyViewModel;
};

export function PolicyReadOnlyFields({ viewPolicy }: Readonly<PolicyReadOnlyFieldsProps>) {
  return (
    <>
      <Grid size={{ xs: 8, md: 4 }}>
        <InfoBox
          label="Policy number"
          value={viewPolicy?.policyNumber || ''}
          testIdLabel="policy-number-label"
          testIdValue="policy-number-value"
        />
      </Grid>
      <Grid size={{ xs: 8, md: 4 }}>
        <InfoBox
          label="Prior policy number"
          value={viewPolicy?.priorPolicyNumber || ''}
          testIdLabel="prior-policy-number-label"
          testIdValue="prior-policy-number-value"
        />
      </Grid>
      <Grid size={{ xs: 8, md: 4 }}>
        <InfoBox
          label="Carrier name"
          value={`${viewPolicy?.carrier?.carrierName || ''} (ID: ${viewPolicy?.carrier?.carrierId || ''})`}
          testIdLabel="carrier-name-label"
          testIdValue="carrier-name-value"
        />
      </Grid>
    </>
  );
}
